/**
 * Vibration, where the browser supports it (`ProductOverview.md` §4.5).
 *
 * iOS Safari has no Vibration API at all, so this is strictly an enhancement: everything it
 * does must also be visible on screen. It also refuses to fire while the tab is hidden, since
 * a phone buzzing in a pocket for a screen nobody is looking at is just rude.
 */

export const hapticsAvailable = (): boolean =>
  typeof navigator !== 'undefined' && typeof navigator.vibrate === 'function';

function buzz(pattern: number | number[]): void {
  if (!hapticsAvailable()) return;
  if (typeof document !== 'undefined' && document.visibilityState === 'hidden') return;

  try {
    navigator.vibrate(pattern);
  } catch {
    // Some browsers throw when vibration is disallowed by user settings. Never a problem.
  }
}

export const haptics = {
  /** One proximity beat. Longer as you get closer, so it is felt as well as seen. */
  pulse: (heat: number): void => buzz(Math.round(18 + heat * 42)),
  /** Crossing into hot/cold range: a short double tap, distinct from the beat. */
  modeChange: (): void => buzz([26, 70, 26]),
  /** You have arrived. */
  arrival: (): void => buzz([60, 90, 60, 90, 140]),
  stop: (): void => buzz(0),
};
